export class Alert {
    public type: AlertTypeEnum = 0;
    public message= '';
    public time?: number;
}

export enum AlertTypeEnum {
    Success,
    Error,
    Info,
    Warning
}
